import { TFunction } from 'i18next'

interface AppealText {
  adults: number
  children: number
  t: TFunction
}

export const useAppealPassengerText = ({ adults, children, t }: AppealText) => {
  const parts: string[] = []

  if (adults) {
    parts.push(
      t(
        adults === 1
          ? 'tours_block.adults_count_one'
          : 'tours_block.adults_count',
        {
          count: adults,
        },
      ),
    )
  }

  if (children) {
    parts.push(
      t(
        children === 1
          ? 'tours_block.child_count_one'
          : 'tours_block.child_count',
        {
          count: children,
        },
      ),
    )
  }

  return parts.join(', ')
}
